<template>
  <div class="event">
    <p v-for="event in events" :key="event.seq">
      <span>{{ event.date | moment('YYYY年MM月DD日') }}</span><br />
      {{ event.name }}
      <span>{{ event.space }}</span>
    </p>
    <span>にて頒布予定</span>
  </div>
</template>

<script>
import events from '@/assets/adeyaka/json/events.json';

export default {
  name: 'Event',
  data() {
    return {
      events: events,
    };
  },
};
</script>

<style lang="scss" scoped>
.event {
  margin-bottom: 40px;
}
p {
  line-height: 30px;
  font-size: 18px;
  margin-bottom: 20px;
  span {
    font-size: 12px;
  }
}
</style>